import React, { useState, useCallback, useEffect } from 'react';
import styled from '@emotion/styled';

import DismissableBanner from './DismissableBanner';
import colors from '../../../styling/colors';
import { getCookie, removeCookie } from '../../../utils/cookie';

const Banner = styled(DismissableBanner)`
  margin: 0;
  width: 100%;
`;

const Content = styled.div`
  color: ${colors('white')};
  align-items: center;
  display: flex;
  font-size: 0.75rem;
  justify-content: space-between;
`;

const ClearLink = styled.a`
  color: ${colors('white')};
  cursor: pointer;
`;

function BuildBanner() {
  const [build, setBuild] = useState(null);

  // empty array in the dependency list
  // because we want this hook to run only once on the client
  useEffect(() => {
    const build = getCookie('build');
    setBuild(build);
  }, []);

  const resetBuild = useCallback(() => {
    removeCookie('build');
    // reload the page. strips all queryparams for now.
    window.location = window.location.pathname;
  }, []);

  if (!build) {
    return null;
  }

  return (
    <Banner
      color={colors('lapel')}
      strokeColor={colors('white')}
      messageId="build"
    >
      <Content>
        <div>PBR SSR Build</div>
        {`Build: ${build}`}
        <ClearLink onClick={resetBuild}>Clear build</ClearLink>
      </Content>
    </Banner>
  );
}

export default React.memo(BuildBanner);
